module.exports = __webpack_public_path__ + "img/weighing-machine.4db6b3ce.svg";